import { render, staticRenderFns } from "./DiseasesBarChart.vue?vue&type=template&id=8b97f102"
import script from "./DiseasesBarChart.vue?vue&type=script&lang=js"
export * from "./DiseasesBarChart.vue?vue&type=script&lang=js"
import style0 from "./DiseasesBarChart.vue?vue&type=style&index=0&id=8b97f102&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports